import React from "react";
import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { CustomSelect, GradeOptions, InterviewTypeOptions, ParentOptions, PreInterviewResultOptions } from "../../../../../../_helpers/Helpers";

export function StudentPreInterviewEditForm({
  id,
  btnRef,
  studentPreInterview,
  saveStudentPreInterview
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={studentPreInterview}
      onSubmit={(values) => {
        saveStudentPreInterview(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <div className="row">
            <div className="col-6">
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Dönem<span> *</span>
                </Form.Label>
                <Col sm={4}>
                  <Form.Control
                    type="number" 
                    min={0}
                    value={values.term}
                    id="term" 
                    placeholder="Dönem"
                    onChange={e => {
                      handleChange(e)
                      handleChange("term2")(e);
                    }}
                  />
                </Col>
                <Col sm={4}>
                  <Form.Control value={values.term + 1} id="term2" readOnly />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="studentName">
                <Form.Label column sm={4}>
                  Öğrenci Adı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.studentName} placeholder="Adı" onChange={handleChange} />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="studentSurname">
                <Form.Label column sm={4}>
                  Öğrenci Soyadı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.studentSurname} placeholder="Soyadı" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="studentGrade">
                <Form.Label column sm={4}>
                  Sınıfı <span>*</span>
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={GradeOptions}
                    value={values.studentGrade}
                    onChange={option => setFieldValue("studentGrade", option.value)}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="studentSchool">
                <Form.Label column sm={4}>
                  Okulu
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.studentSchool} placeholder="Okulu" onChange={handleChange} />
                </Col>
              </Form.Group>
            </div>
          
            <div className="col-6">
              <Form.Group as={Row} controlId="result">
                <Form.Label column sm={4}>
                  Durum
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={PreInterviewResultOptions}
                    value={values.result}
                    onChange={option => setFieldValue("result", option.value)}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="parentName">
                <Form.Label column sm={4}>
                  Veli Adı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentName} placeholder="Veli Adı" onChange={handleChange} />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="parentSurname">
                <Form.Label column sm={4}>
                  Veli Soyadı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentSurname} placeholder="Veli Soyadı" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="parentPhone">
                <Form.Label column sm={4}>
                  Veli Telefonu<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentPhone} placeholder="Veli Telefonu" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="relationship">
                <Form.Label column sm={4}>
                  Veli Yakınlığı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={ParentOptions}
                    value={values.relationship}
                    onChange={option => setFieldValue("relationship", option.value)}
                  />
                </Col>
              </Form.Group>
            </div>
          </div>
          
          {
            !id &&
            <>
              <hr />
              <div className="row mt-10">
                <div className="col-6">
                  <Form.Group as={Row} controlId="date">
                    <Form.Label column sm={4}>
                      Görüşme Tarihi<span> *</span>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control type="date" value={values.date} placeholder="Görüşme Tarihi" onChange={handleChange} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="interviewType">
                    <Form.Label column sm={4}>
                      Görüşme Türü
                    </Form.Label>
                    <Col sm={8}>
                      <CustomSelect 
                        options={InterviewTypeOptions}
                        value={values.interviewType}
                        onChange={option => setFieldValue("interviewType", option.value)}
                      />
                    </Col>
                  </Form.Group>
                </div>

                <div className="col-6">
                  <Form.Group as={Row} controlId="trackingDate">
                    <Form.Label column sm={4}>
                      Takip Tarihi<span> *</span>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control type="date" value={values.trackingDate} placeholder="Takip Tarihi" onChange={handleChange} />
                    </Col>
                  </Form.Group>
                </div>
              </div>

              <Form.Group as={Row} controlId="explanation">
                <Form.Label column sm={2}>
                  Açıklama<span> *</span>
                </Form.Label>
                <Col sm={10}>
                  <Form.Control 
                    as="textarea"
                    rows="2"
                    placeholder="Açıklama"
                    value={values.explanation}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
            </>
          }

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}